// user roles

export const USER_ROLES = {
  ADMIN: "admin",
  MANAGER: "manager",
  TEAM: "team",
  USER: "user",
};
// Order item mapping status
export const CONTAINER_ITEM_MAPPING_STATUS = {
  SUSPENSE: "suspense",
  CLEARED: "cleared",
};

// Order type
export const ORDER_TYPE = {
  BASED_ON_DONE: "basedOnDone",
  CARRYING: "carrying",
};

// Shipment type
export const SHIPMENT_TYPE = {
  BY_SEA: "bySea",
  BY_AIR: "byAir",
};

// Order status
export const ORDER_STATUS = {
  DRAFT: "draft",
  PLACED: "placed",
  PROCESSING: "processing",
  FULFILLED: "fulfilled",
  DELIVERED: "delivered",
  CANCELLED: "cancelled",
};

// Container status
export const CONTAINER_STATUS = {
  DISPATCHED: "dispatched",
  LOADED: "loaded",
  ARRIVED: "arrived",
  RECEIVED: "received",
  CREATED: "created",
};
